import useWindowResize from '@/hooks/useWindowResize';
import { SideContext } from '@/screens/PHR';
import * as React from 'react';

export interface IRenderLinesProps {
  svgRef: any;
}

const RenderLines: React.FC<IRenderLinesProps> = ({ svgRef, ...props }) => {
  useWindowResize();
  const [wait, setWait] = React.useState<boolean>(false);
  const { isCollapsed } = React.useContext(SideContext);
  const svgElement: HTMLElement = svgRef.current as unknown as HTMLElement;
  const lines = [];

  React.useEffect(() => {
    setWait(false);
    const timer = setTimeout(() => setWait(true), 300);
    return () => clearTimeout(timer);
  }, [isCollapsed]);

  if (svgElement) {
    const buttonNodes = Array.from(document.querySelectorAll('.btn-he-co-quan'));

    const logoCenter = getCoordinates(document.querySelector('.logo-vclass'), 'center');

    const svgContainer = getCoordinates(svgElement);
    for (const key in buttonNodes) {
      const e: any = buttonNodes[key];

      const btn = getCoordinates(e as HTMLElement, Number(key) % 2 ? 'left-center' : 'right-center');

      if (btn && logoCenter && svgContainer) {
        const x1 = btn.x - svgContainer.x;
        const y1 = btn.y - svgContainer.y;
        const x2 = logoCenter.x - svgContainer.x;
        const y2 = logoCenter.y - svgContainer.y;

        // Tính chiều dài của đường thẳng gốc
        const originalLength = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        // Tính tọa độ mới của đầu điểm p1
        const newX1 = x1 + ((x2 - x1) / originalLength) * 30;
        const newY1 = y1 + ((y2 - y1) / originalLength) * 30;

        // Tính tọa độ mới của đầu điểm p2
        const newX2 = x2 - ((x2 - x1) / originalLength) * 40;
        const newY2 = y2 - ((y2 - y1) / originalLength) * 40;

        lines.push(<line key={`line-${key}`} x1={newX1} y1={newY1} x2={newX2} y2={newY2} stroke="white" />);
      }
    }
    return wait ? <>{lines}</> : null;
  }
  return null;
};

export default RenderLines;

function getCoordinates(
  element: HTMLElement | null,
  type?: 'center' | 'left-center' | 'right-center',
): { x: number; y: number } | null {
  if (element) {
    const rect = element.getBoundingClientRect();
    let x: number = rect.left;
    let y: number = rect.top;

    switch (type) {
      case 'center':
        x = rect.left + rect.width / 2;
        y = rect.top + rect.height / 2;

        break;
      case 'left-center':
        x = rect.left;
        y = rect.top + rect.height / 2;
        break;
      case 'right-center':
        x = rect.left + rect.width;
        y = rect.top + rect.height / 2;
        break;

      default:
        break;
    }

    return { x, y };
  } else {
    console.error('Đối tượng không phải là một HTMLElement.');
    return null;
  }
}
